<template>
    <div id="m-inbox" style="height: 100%">
        <popup-edit-version ref="popup-edit-version"></popup-edit-version>
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <v-card-actions class="ma-0 pa-2" v-if="isProduction()">
                <v-alert type="warning" dense width="100%">Only deploy log (Staging -> Production)</v-alert>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-2" v-if="!isDevelopment()">
                <v-card elevation="0" width="100%">
                    <v-card elevation="0" width="100%" v-for="r in assetUploadResult">
                        <v-card-actions class="ma-0 pa-0">
                            <v-card :color="r.success == 'OK' ? 'success' : 'error'" width="100%" class="white--text mb-1" elevation="0">
                                <v-card-actions>
                                    <v-icon class="mr-2" color="white">mdi-alert-circle-outline</v-icon>
                                    {{r.name}}
                                </v-card-actions>
                            </v-card>
                        </v-card-actions>
                    </v-card>
                </v-card>
            </v-card-actions>
            <v-card-actions v-if="!isProduction()">
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-2">
                        <v-card elevation="0" class="ma-0 pa-0">
                            <v-card-actions>
                                <v-btn elevation="0" color="blue" @click="editVersion">
                                    <v-card-title ref="versionValue" class="white--text">{{minVersion.join(".")}} - {{maxVersion.join(".")}}</v-card-title>
                                    <v-icon size="20" color="white">mdi-pencil</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-checkbox label="Localization" class="ml-5" v-model="localization"></v-checkbox>
                        <v-spacer></v-spacer>
                        <v-btn :loading="deployng"
                               :disabled="!ifCanDeployToNext()"
                               color="green"
                               elevation="0"
                               class="white--text pl-5 pr-3"
                               @click="onPressDeploy">
                            deploy {{getDeployButtonName()}}
                            <v-icon class="ml-2">mdi-bird</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
            <v-card-actions class="pt-0" v-if="!isProduction()">
                <v-card width="100%" class="ma-0 pa-0" elevation="0">
                    <d-list-table ref="d-list-table"></d-list-table>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import DListTable from "@/modules/mdeploy/views/d-list-table";
import {DeployStoreUtils} from "@/modules/mdeploy/database/DeployStoreUtils";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import {SlackLogManager} from "@/common/SlackLogManager";
import PopupEditVersion from "@/modules/common/popup-edit-version";

export default {
    components: {PopupEditVersion, DListTable},
    data: () => ({
        deployng:false,
        loading: true,
        message: "",
        localization:true,
        minVersion:[0,0,0],
        maxVersion:[0,0,0],
    }),
    computed:{
        pendingItems(){
            return DeployStoreUtils.getPendingForDeploy()
        },
        assetUploadResult(){
            return DeployStoreUtils.getAssetUploadResult()
        }
    },
    methods: {
        getMyUserUid(){
            return PermissionsStoreUtils.getMyUserUid();
        },
        ifCanDeployToNext(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.DEPLOY_TAB.subpermissions.DEPLOY_TAB_DEPLOY_TO_NEXT.id)
        },
        isDevelopment(){
          return process.env.VUE_APP_FB_PROJECTID == 'mira-merge---development'
        },
        isProduction(){
            return process.env.VUE_APP_FB_PROJECTID == 'mira-merge---production'
        },
        getDeployButtonName(){
            let name = ''
            if(process.env.VUE_APP_FB_PROJECTID == 'mira-merge---development'){
                name = 'TO STAGING'
            }else if (process.env.VUE_APP_FB_PROJECTID == 'mira-merge---staging'){
                name = 'TO PRODUCTION'
            }
            return name
        },
        editVersion(){
            let self = this;
            let ref = this.$refs['popup-edit-version'];
            ref.show(this.minVersion.join("."),this.maxVersion.join("."), function (min, max) {
                self.minVersion = min.split(".");
                self.maxVersion = max.split(".");
                ref.hide();
            });
        },
        onPressDeploy(){
            this.$confirm("Are you sure?")
            .then(() => {

                let miver = this.minVersion.join(".");
                let maxver = this.maxVersion.join(".");

                if (miver == "0.0.0" || maxver == "0.0.0"){
                    this.$notify({title: 'Set up files version!', type: "error"});
                    return;
                }

                let data = [];

                if (this.pendingItems.length != 0){

                    let aud = this.$refs['d-list-table'].aud;
                    if (Object.keys(aud).length == 0){
                        this.$notify({title: 'No audience!', type: "error"});
                        return;
                    }

                    for (var i in this.pendingItems){
                        let fileName = this.pendingItems[i];
                        if (Object.hasOwn(aud, fileName)){
                            data.push({name:fileName, aud:aud[fileName].map(e => e.name).join(","), minver:miver, maxver:maxver});
                        }
                    }
                }

                if (this.localization){data.push({name:'l_name'})}

                if (Object.keys(data).length == 0){
                    this.$notify({title: 'Empty Data!', type: "error"});
                    return;
                }

                this.deployng = true;

                DeployStoreUtils.crossDeploy(data)
                .then(() => {
                    this.deployng = null
                    this.$notify({title: 'Deploy deleted!', text: "", type: "succes"});
                    this.slackDeployLog(data);
                })
                .catch((error) => {
                    this.deployng = null
                    this.$notify({title: 'Deploy failed!', text: error, type: "error"});
                })

            }).catch(() => {})
        },
        slackDeployLog(data){
            let deployData = {
                'icon_emoji': ':hammer:',
                'text': "<@"+PermissionsStoreUtils.getMyName()+"> deploy to next environment",
                'attachments': [{
                    'color': '#0349fc',
                    'fields': [
                        {"title": "Environment", 'value': SlackLogManager.getEnv(), 'short': true},
                        {"title": "Files", 'value': data.map(e=>e.name).join(", "), 'short': true},
                    ]
                }]
            }
            SlackLogManager.log(deployData)
        },
    },
    beforeMount() {
        if (this.isDevelopment() == false){
            DeployStoreUtils.fethAssetUploadResult();
        }
        this.loading = false
    },
}
</script>

<style scoped>
</style>